/*global define */
define(function () {
    const ExpandCollapseBlock = function() {
        this.addEventListener = $container => {
            const $bulletContainer = $container.find('.bullet-container');
            const $header = $container.find('.header');
            
            // slide the bullet container
            $header.on("click", () => {
                $bulletContainer.animate({
                    height: "toggle",
                    opacity: "toggle"
                }, "fast");
                
                $header.toggleClass("arrow-up");
            });
        };
    };

    return ExpandCollapseBlock;
});